import { Schema } from "effect";
import { MessageAttachmentId } from "../../../../ids/definitions";

/**
 * Visibility level for attachments stored in S3
 * - public: File has a direct URL, accessible without authentication
 * - private: File requires a signed URL generated on-demand
 */
export const AttachmentVisibility = Schema.Literal("public", "private");
export type AttachmentVisibility = typeof AttachmentVisibility.Type;

/**
 * Discriminator for inline (cid:-referenced) vs regular file attachments
 */
export const AttachmentType = Schema.Literal("inline", "attachment");
export type AttachmentType = typeof AttachmentType.Type;

/**
 * Attachment object returned to clients
 * Always includes a URL (presigned for private attachments)
 *
 * `contentId` and `type` are optional — set when this attachment is an
 * inline (cid:) image referenced from an HTML email body. Older payloads
 * without these fields decode cleanly to undefined.
 */
export const Attachment = Schema.Struct({
  id: MessageAttachmentId,
  url: Schema.String,
  description: Schema.OptionFromNullOr(Schema.String),
  mimeType: Schema.OptionFromNullOr(Schema.String),
  contentId: Schema.optional(Schema.OptionFromNullOr(Schema.String)),
  type: Schema.optional(Schema.OptionFromNullOr(AttachmentType)),
});

export type Attachment = typeof Attachment.Type;
